<template>
      <div class="learners-banner" :style="`--data-height:${dataHeight}px`">
        <div class="bg-element" v-bind:style="{backgroundImage:'url('+pattern+')'}" >	</div>
        <div class="col s12">
        <h2 class="" style="z-index: 99; position:relative" v-text="dataTitle"></h2>
   
      </div>
    <slot></slot>
      </div>
</template>
<script>
import pattern from '@/assets/web.svg'
export default {
  name:'learnersBg',
  props: {
    dataHeight: {
      type: [Number, String],
      default: '250'
    },
    dataTitle:{
      type: String,
      default:'Set Title'
    }
  },
  data () {
    return {
      pattern
    }
  }
}
</script>
<style scoped lang="scss">
.learners-banner {
    background:rgb(250, 250, 250);
    padding: 46px 8px;
    background-size: 50%;
    background-position: right top;
    background-repeat: no-repeat;
		height:var(--data-height);
    position: relative;
		overflow: hidden;
    @media screen and (max-width:768px) {
      padding: 24px 16px;
    }
    .bg-element {
      position: absolute;
      top:0;
      right:0px;
      height: calc(100% + 64px);
      width:45%;
      background-size: cover !important;
      z-index: 0;
    opacity: .4;
    }
    .user-title {
      font-size:32px;
      margin:12px 0px;
      line-height: 1;
    }
    .short-text {
      p {
        font-size:17px;
        line-height: 1.6; 
        opacity: .9;
        margin:4px 0px 16px;
      }
    }
}


</style>